<template>
  <div class="charts-wrap" ref="chartRef"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "ChartsModal",
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
      xAxisList: [],
    };
  },
  mounted() {
    for (let i = 0; i < 30; i++) {
      let a = "第 " + (i + 1) + " 日";
      this.xAxisList.push(a);
    }
    this.initCharts();
  },
  methods: {
    initCharts() {
      let chartDom = this.$refs.chartRef;
      let myChart = echarts.init(chartDom);
      window.onresize = myChart.resize;
      this.myChart = myChart;
      this.renderData();
    },
    renderData() {
      let option = {
        title: {
          text: "30日新增曲线",
          left: "center",
          bottom: "15",
          textStyle: {
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "10",
          left: "5%",
          right: "5%",
          bottom: "60",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.xAxisList,
          axisLabel: {
            align: "center",
            // ...
          },
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          axisLine: { show: false },
          axisTick: { show: false },
        },
        series: [
          {
            data: this.dataList,
            type: "line",
            smooth: true,
          },
        ],
      };
      this.myChart.clear();
      this.myChart.setOption(option);
    },
  },
  watch: {
    dataList(value) {
      if (value) {
        this.renderData();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.charts-wrap {
  height: 500px;
}
</style>
